import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { styles } from '../../style/style';
import axios from '../api/axiosConfig';

/** Parse MM/DD/YYYY or YYYY-MM-DD to Date (midnight local). Returns null if invalid. */
function parseDateToDate(value) {
    if (!value || typeof value !== 'string' || value.length < 10) return null;
    let month, day, year;
    if (value[2] === '/' && value[5] === '/') {
        month = parseInt(value.slice(0, 2), 10);
        day = parseInt(value.slice(3, 5), 10);
        year = parseInt(value.slice(6, 10), 10);
    } else if (value[4] === '-' && value[7] === '-') {
        year = parseInt(value.slice(0, 4), 10);
        month = parseInt(value.slice(5, 7), 10);
        day = parseInt(value.slice(8, 10), 10);
    } else {
        return null;
    }
    if (month < 1 || month > 12 || day < 1 || day > 31) return null;
    const d = new Date(year, month - 1, day);
    if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) return null;
    return d;
}

/** True if today (local date) is >= start and <= end (inclusive). */
function isTodayInRange(startStr, endStr) {
    const start = parseDateToDate(startStr);
    const end = parseDateToDate(endStr);
    if (!start || !end) return false;
    const today = new Date();
    const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return t.getTime() >= start.getTime() && t.getTime() <= end.getTime();
}

const NewsMessage = () => {
    const ApiList = useSelector((state) => state.apiList.apiList);
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchNewsMessages = useCallback(() => {
        const url = ApiList?.getnewsmessages;
        axios.get(url, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            const list = response.data?.newsMessages;
            setMessages(Array.isArray(list) ? list : []);
        }).catch(() => {
            setMessages([]);
        }).finally(() => {
            setLoading(false);
        });
    }, [ApiList?.getnewsmessages]);

    useEffect(() => {
        fetchNewsMessages();
    }, [fetchNewsMessages]);

    const messageForToday = messages.find((m) => isTodayInRange(m.startDate, m.endDate));

    if (loading) {
        return (
            <Box sx={{ pr: '2%' }}>
                <Typography id="newsTitle" variant="h3" sx={styles.h3SectionTitle}>
                    <FormattedMessage id="newsmessage.appname" defaultMessage="News" />
                </Typography>
                <Typography variant="body1" sx={styles.pBodyText}>...</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ pr: '2%' }}>
            <Typography id="newsTitle" variant="h3" sx={styles.h3SectionTitle}>
                <FormattedMessage id="newsmessage.appname" defaultMessage="News" />
            </Typography>
            {messageForToday ? (
                <>
                    <Typography id="newsName" variant="h4" sx={styles.h4InformationGroupHeader}>
                        {messageForToday.title}
                    </Typography>
                    <br />
                    <Typography id="newsBody" variant="body1" component="p" sx={styles.pBodyText}>
                        {messageForToday.message}
                    </Typography>
                </>
            ) : (
                <Typography id="newsNoMessage" variant="body1" component="p" sx={styles.pBodyText}>
                    <FormattedMessage id="newsmessage.noMessageToday" defaultMessage="There currently is no news message to be displayed." />
                </Typography>
            )}
        </Box>
    );
};
export default NewsMessage;
